import { ContainerDefaults } from '@volosoft/ngx-lepton-x/layouts';

export const FULL_WIDTH_LAYOUT_CLASS = 'full';

export const LPX_LAYOUT_STORAGE_KEY = 'LPX_LAYOUT';

// US #153472 drops the Container Width picker and fixes the product to full width. Reusing LeptonX's own
// entry rather than declaring a new one keeps its label and icon in step with the theme package.
export const ACX_CONTAINERS = ContainerDefaults.filter(
  container => container.layoutClass === FULL_WIDTH_LAYOUT_CLASS,
);
